<!-- eslint-disable vue/multi-word-component-names -->
<script>
import Footer from "@/components/Footer";
import { reactive, ref } from "@vue/reactivity";
import axios from "axios";
import { useStore } from "vuex";
import { onMounted } from "@vue/runtime-core";
import { formatDate } from "@/assets/js/utils";
import { useRoute } from "vue-router";
import { ShareNetwork } from "vue-social-sharing";
import Placeholder from "@/components/Placeholder.vue";
import NavbarSecondDark from "@/components/NavbarSecondDark.vue";
import "@vueup/vue-quill/dist/vue-quill.snow.css";

export default {
  components: {
    Footer,
    ShareNetwork,
    Placeholder,
    NavbarSecondDark,
  },
  setup() {
    let store = useStore();
    let route = useRoute();
    let tab = ref(0);
    let result = reactive({
      data: null,
      loading: false,
    });
    let related = reactive({
      data: null,
      loading: false,
    });
    let latest = reactive({
      data: null,
      loading: false,
    });
    let tags = ref([]);

    function fetchData(url) {
      result.loading = true;
      axios
        .get(url)
        .then((response) => {
          result.data = response.data.data;
          tags.value = response.data.data.tags;
          getRelated();
          result.loading = false;
          axios.post(`${store.state.urlNews}viewer/read`, {
            news_id: response.data.data.uuid,
          });
        })
        .catch((error) => {
          console.log(error);
          result.loading = false;
        });
    }

    function getRelated() {
      related.loading = true;
      axios
        .get(`${store.state.urlNews}viewer/related`, {
          params: {
            category_id: result.data.category_id,
            tags: tags.value,
            uuid: result.data.uuid,
          },
        })
        .then((response) => {
          related.data = response.data.data;
          related.loading = false;
        })
        .catch((error) => {
          console.log(error);
          related.loading = false;
        });
    }

    function getLatest() {
      latest.loading = true;
      axios
        .get(`${store.state.urlNews}viewer/latest?skip=0&take=10`)
        .then((response) => {
          latest.data = response.data.data;
          latest.loading = false;
        })
        .catch((error) => {
          console.log(error);
          latest.loading = false;
        });
    }

    onMounted(() => {
      fetchData(`${store.state.urlNews}viewer/${route.params.id}/show`);
      getLatest();
    });

    return {
      tab,
      result,
      latest,
      related,
      formatDate,
      route,
      fetchData,
      store,
    };
  },
  watch: {
    "route.params": function (val) {
      this.fetchData(`${this.store.state.urlNews}viewer/${val.id}/show`);
    },
  },
};
</script>

<template>
  <div>
    <NavbarSecondDark />
    <section class="container-xl my-5 px-lg-5">&nbsp;</section>

    <section class="container-xl my-5 px-lg-5">
      <div class="row">
        <div class="col-lg-8" v-if="result.loading">
          <Placeholder />
        </div>
        <div class="col-lg-8" v-if="result.data != null">
          <div class="row">
            <div class="col-lg-12">
              <div class="h3" style="color: #122B4F;">
                {{ result.data.title }}
              </div>
            </div>
            <div class="col-lg-12 mb-3 d-flex gap-3">
              <p class="small" style="color: #122B4F;">
                {{ formatDate(result.data.created_at, "LL") }}
              </p>
              <p class="small" style="color: #122B4F;">
                <i class="fas fa-eye"></i> {{ result.data.reads_count }}
              </p>
            </div>
            <div class="col-lg-12 mb-3">
              <img :src="result.data.photos[0].path_formated" class="border-0 rounded-custom" alt="..."
                style="width: 100%" />
            </div>
            <div class="col-lg-12 ql-editor" v-html="result.data.content"></div>
            <div class="col-lg-12">
              <hr />
              <div class="d-flex justify-content-start">
                <ShareNetwork network="facebook" :url="store.state.feLiveUrl + route.fullPath"
                  :title="result.data.title" :description="result.data.quote"
                  class="btn btn-success rounded-circle me-2" style="width: 40px; height: 40px">
                  <i class="fab fa-facebook"></i>
                </ShareNetwork>
                <ShareNetwork network="whatsapp" :url="store.state.feLiveUrl + route.fullPath"
                  :title="result.data.title" :description="result.data.quote"
                  class="btn btn-success rounded-circle me-2" style="width: 40px; height: 40px">
                  <i class="fab fa-whatsapp"></i>
                </ShareNetwork>
                <ShareNetwork network="twitter" :url="store.state.feLiveUrl + route.fullPath" :title="result.data.title"
                  :description="result.data.quote" class="btn btn-info rounded-circle me-2"
                  style="width: 40px; height: 40px">
                  <i class="fab fa-twitter"></i>
                </ShareNetwork>
                <ShareNetwork network="line" :url="store.state.feLiveUrl + route.fullPath" :title="result.data.title"
                  :description="result.data.quote" class="btn btn-success rounded-circle me-2"
                  style="width: 40px; height: 40px">
                  <i class="fab fa-line"></i>
                </ShareNetwork>
              </div>
              <hr />
              <div class="row">
                <div class="col-lg-12 mb-3 fw-bold text-uppercase" style="color: #122B4F;">{{ $t('RelatedNews') }}</div>
                <div class="col-lg-4" v-for="(data, i) in related.data" :key="i">
                  <router-link :to="{ name: 'NewsDetail', params: { id: data.uuid } }" class="text-primary-mice">
                    <div class="card mb-3 border-0 rounded-custom">
                      <img :src="data.photos[0].path_formated" class="card-img-top border-0 rounded-custom"
                        alt="news.title" style="min-width: 198px; min-height: 129px" />
                      <div class="card-body px-0">
                        <h6 class="card-title one-line" style="color: #122B4F;">
                          {{ data.title }}
                        </h6>
                        <small style="color: #122B4F;">{{ data.created_at_formatted }}</small>
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4" v-if="latest.loading">
          <Placeholder />
        </div>
        <div class="col-lg-4" v-if="latest.data != null">
          <div class="row">
            <div class="col-lg-12 mb-4">
              <hr class="d-lg-none" />
              <div class="h5 fw-bold" style="color: #122B4F;">{{ $t('LatestNews') }}</div>
            </div>
            <div class="col-lg-12" v-for="(data, i) in latest.data" :key="i">
              <router-link :to="{ name: 'NewsDetail', params: { id: data.uuid } }">
                <div class="h6 text-primary-mice two-line" style="color: #122B4F;">
                  {{ data.title }}
                </div>
                <hr />
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer />
  </div>
</template>
